import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { AtividadeTipoPipe } from './atividade-tipo.pipe';
import { AtividadeTipoIconPipe } from './atividade-tipo-icon.pipe';
import { AtividadeTipoMotivoConclusaoBloqueadaPipe } from './atividade-tipo-motivo-conclusao-bloqueada.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        // Pipes
        AtividadeTipoPipe,
        AtividadeTipoIconPipe,
        AtividadeTipoMotivoConclusaoBloqueadaPipe
    ],
    exports: [
        SharedModule,

        // Pipes
        AtividadeTipoPipe,
        AtividadeTipoIconPipe,
        AtividadeTipoMotivoConclusaoBloqueadaPipe
    ],
    providers: [
        // Pipes
        AtividadeTipoPipe,
        AtividadeTipoIconPipe,
        AtividadeTipoMotivoConclusaoBloqueadaPipe
    ]
})
export class AtividadeTipoPipeModule { }
